import React from 'react';
import useCurrentUser from '../../hooks/useCurrentUser';
import BaseWelcomeLetter from '../Application/BaseWelcomeLetter';

export const getPtaWelcomeLetterItems = (companyName) => [
    // 0: Header / Intro
    {
        id: 0,
        type: 'intro',
        company: companyName,
        title: "Employee's Welcome Letter And Agreement",
        salutation: "Dear",
        salutationSuffix: "PTA.",
        fields: [
            { name: "employeeName", placeholder: "Employee Name" }
        ],
        text: `We at ${companyName} welcome you to our office and we want you to know that we have established an open line of communication with all our employees. Please feel free to speak to us at any time. Kindly, note that:`
    },
    // 1: Hire Date
    {
        id: 1,
        type: 'field',
        label: "Your Official Date of Hire is:",
        name: "hireDate",
        inputType: "date",
        required: true
    },
    // 2: Supervisor
    {
        id: 2,
        type: 'field',
        label: "Your Immediate Supervisor is:",
        name: "supervisorName",
        placeholder: "Supervisor Name",
        required: true,
        disabled: true
    },
    // 3: Pay Rates Header
    {
        id: 3,
        type: 'text_header',
        text: "Your Rates of Pay as PTA are as follow:"
    },
    // 4: Pay Rate - Regular Visit only
    {
        id: 4,
        type: 'pay_rate',
        label: "Regular Visit",
        name: "payRate.regular_visit",
        unit: "per visit"
    },
    // 5: Probationary
    {
        id: 5,
        type: 'text_block',
        text: "Your Probationary Period ends three months after your date of hire/your first patient care; on ...................... at which your performance will be evaluated and there will be yearly evaluation thereafter. Full time Employee's Benefits begin after the probationary period (if applicable). Physical Exams and Chest X-Rays are due every two years; however, the PPD is only valid for one year."
    },
    // 6: Policy Agreement
    {
        id: 6,
        type: 'text_block',
        text: "You are expected to review our Policies and Procedures and you agree that you have Reviewed AND Understood our Safety Rules, Labor Laws/Sexual Harassment Rules, our Dress Code, your Job Description, Patient/Employee Confidentiality, our Policy on Child and Elder Abuse and you have Filled out all the required information accurately, to the best of your knowledge."
    },
    // 7: CEU Submission
    {
        id: 7,
        type: 'text_block',
        text: "In accordance with our policy and procedures we ask you kindly to submit any CEU's for your In-Service file."
    },
    // 8: Agreement Header
    {
        id: 8,
        type: 'section_header',
        title: "AGREEMENT"
    },
    // 9: Section 1 - Confidentiality Statement
    {
        id: 9,
        type: 'section',
        title: "1- CONFIDENTIALITY STATEMENT",
        text: `I understand that in the performance of my duties as an employee of ${companyName}, I may have access to, and may be involved in the processing of patient information. I understand that I am obligated to maintain the confidentiality of this patient information at all times, both at work and off duty.`,
        bullets: [
            "I understand that violation of these confidentiality considerations may result in disciplinary action, including termination. I further understand that I could be subjected to legal action.",
            "I understand that I am not to interpret, discuss, or otherwise relay medical or personal information about the patients, unless necessary during the course of fulfilling my job duties.",
            "I certify by my signature that, I have participated in the orientation and training concerning the privacy and confidentiality considerations of the Patient's Information."
        ]
    },
    // 10: Section 2 - Child Abuse Reporting Requirements
    {
        id: 10,
        type: 'section',
        title: "2- Child Abuse Reporting Requirements",
        text: "Section 11166 of the Penal Code requires that any childcare custodian, health practitioner or employee of a child protective agency who has knowledge of or observes a child in his or her professional capacity or within the scope of his or her employment that he or she knows or reasonably suspects has been the victim of child abuse to report the known or suspected instance of child abuse to a child protective agency immediately or as soon as practically possible by telephone and to prepare and send a written report thereof within 36 hours of receiving the information concerning the incident.",
        definitions: [
            {
                term: "Child Care Custodian",
                def: "\"Child Care Custodian\" includes teachers; an instructional aide, a teacher's aide, or a teacher's assistant employed by any public or private school, who has been trained in the duties imposed by this article if the school district has so warranted to the State Department of Education; a classified employee of any public or private school, if the school has so warranted to the State Department of Education; administrative officers, supervisors of child welfare and attendance, or certified pupil personnel employees of any public or private school; administrators of a public or private day camp, administrators and employees of any public or private youth centers, youth recreations programs and youth organizations; administrators or employees of public or private organizations whose duties require direct contact and supervision of children and who have been trained in the duties imposed by this article, licenses, administrators and employees of licensed community care of child day care facilities; head start teachers; licensing worker; or licensing evaluators; public assistance workers; employees of a child care institution including, but not limited to, foster parents, group home personnel and personnel of residential care facilities; social workers, probation officers or parole officers; employees of a school district police or security department; or any person who is an administrator or presenter of, or counselor in, a child abuse prevention program in any public or private school."
            },
            {
                term: "Health Practitioner",
                def: "\"Health Practitioner\" includes physicians and surgeons, psychiatrists, psychologists, dentists, residents, interns, podiatrist, chiropractors, licensed nurses, dental hygienists, optometrists, or any other person who is licensed under Division 2 (commencing with Section 500) of the Business & Professional code; marriage, family and child counselors; emergency medical technicians I or II, paramedics, or other persons certified pursuant to Division 25 (commencing with Section 1797) of the Health & Safety code; psychological assistants registered pursuant to Section 2913 of the Business & Professional code; marriage, family and child counselor trainee; as defined in subdivision (C) of Section 4980.03 of the Business & Professional Code: state or county public health employees who treat minors for venereal disease or any other condition; coroners; Paramedics, and religious practitioners who diagnose, examine or treat children."
            }
        ]
    },
    // 11: Section 3 - Elder and Dependant Adult Abuse Reporting Responsibility
    {
        id: 11,
        type: 'section',
        title: "3- Elder and Dependant Adult Abuse Reporting Responsibility",
        text: "The California legislature has adopted mandatory reporting requirements for dependent adult and elder abuse. Two aspects of the law are of particular concern to physician:",
        content_after: [
            {
                mode: 'p',
                text: "The scope of physician's reporting obligation under the law, and\nThe obligation of all physicians and other employers who employ licensed health care practitioners or other mandated reports to provide these employees with a copy of a statement explaining their reporting obligations, and to obtain a signed statement from those employees hired on or after January 1, 1986, acknowledging these responsibilities."
            },
            {
                mode: 'subheading',
                text: "Mandatory Reporting:"
            },
            {
                mode: 'p',
                text: "Reporting is required of physicians, nurses, pharmacies and all other medical practitioners licensed under Division 2 of the Business and Professional Code. Reporting is also required of certain non-medical practitioners, such as coroners, social workers, psychologists, family counselors, nursing home ombudsmen, care custodians (certain individuals who work directly with elders or dependent adults as part of their official duties, law officers and probation and welfare personnel). The obligation does not extend to members of physician's office support staff who are not licensed health care providers. One individual may make the required report for an entire group, and facilities may develop reporting protocols, so long as they are consistent with the statutory requirements. However, if a member of a group learns that the designated individual has failed to make the report, he or she must make the report as soon as practically possible."
            },
            {
                mode: 'subheading',
                text: "Abuse Which Must Be Reported:"
            },
            {
                mode: 'p',
                text: "Those subject to the reporting obligation must reopen when, within their professional capacity or the scope of their employment; they either:"
            },
            {
                mode: 'list',
                items: [
                    "1. Observe an incident that reasonably appears to be physical abuse;",
                    "2. Observe a physical injury where the nature of the injury, its location on the body or the repetition of the injury, clearly indicates that physical abuse has occurred;",
                    "3. Are told by an elder or dependent adult that he or she has experienced behavior constituting physical abuse."
                ]
            },
            {
                mode: 'p',
                text: "\"Physical abuse\" which must be reported includes in addition to physical or sexual assault or barrier, the use of physical or chemical restraints or psychotropic medication:"
            },
            {
                mode: 'list',
                items: [
                    "1. For punishment;",
                    "2. For a period of time significantly longer than that for which the restraint or medication was authorized by the instructions of a physician providing medical care to the elder or dependent adult at the time the instructions were given; or",
                    "3. For any purpose not consistent with the authorization of the physician. It is the opinion of CNIA legal counsel that the law does not require reporting of cases involving the appropriate withholding or removal of life-sustaining treatment as otherwise authorize by law."
                ]
            },
            {
                mode: 'p',
                text: "\"Dependent adults\" covered by the law include any person residing in California between the ages of 18 and 64 who have physical or mental limitations which restrict their ability to carryout normal activities and protect their rights, and specifically includes all hospital inpatients."
            },
            {
                mode: 'p',
                text: "\"Elders\" covered by the law include all persons residing in California 65 years of age or older."
            },
            {
                mode: 'subheading',
                text: "Discretionary Reporting:"
            },
            {
                mode: 'p',
                text: "Those required to report physical abuse as described above may, but are not required to report known or reasonably suspected instances of other types of elder or dependent adult abuse, including cases of mental abuse, fiduciary abuse, neglect, abandonment, isolation. or other treatment with resulting physical harm or pain or mental suffering, or the deprivation by a care custodian of goods or services that are necessary to avoid physical harm or mental suffering."
            },
            {
                mode: 'subheading',
                text: "\"Isolation\" includes:"
            },
            {
                mode: 'list',
                items: [
                    "1. Acts intended to prevent, and that do prevent, an elder or dependent adult from receiving mail or telephone calls;",
                    "2. Telling a caller of prospective visitor that an elder or dependent adult is not present, or does not wish to talk with the caller or to meet with the visitor, where the statement is false, contrary to the express wishes of the elder or dependent adult from having contact with family, friends or concerned persons;",
                    "3. False imprisonment (as defined in Penal Code 236); and",
                    "4. Physical restraint of an elder or dependent adult for the purpose of preventing the person from meeting with visitors."
                ]
            },
            {
                mode: 'p',
                text: "The above acts are subject to a rebuttal presumption that they do not constitute isolation if they are performed pursuant to the instructions of a physician who is caring for the elder or dependent adult and who gives the instructions as part of the person's medical care. Furthermore, the above acts do not constitute isolation if they are performed in response to a reasonably perceived threat of danger to property or physical safety."
            },
            {
                mode: 'subheading',
                text: "Reports:"
            },
            {
                mode: 'p',
                text: "Reports by telephone and in writing must be made to:"
            },
            {
                mode: 'list',
                items: [
                    "1. The long term care ombudsman coordinator or local law enforcement agency (the city police or County sheriffs department, or county probation's department) when the abuse is alleged to have occurred in a long-term care facility; or",
                    "2. To the county adult protective services agency (County Welfare Department) or a local law enforcement agency when the abuse is alleged to have occurred anywhere else."
                ]
            },
            {
                mode: 'p',
                text: "Both the telephone and written report should include unless the information is unavailable to the reporter, the name, address, telephone number and occupation of the person making the report, the name and address of the victim, the date, time and place of the incident, other details, including the reporter's observations and beliefs concerning the incident, any statement relating to the incident, and the name of the individuals believed to be responsible for the incident and their connection to the victim. The written report is to be on a standardized form which should be available from County adult protective services agencies, and must be sent within two working days of notice of the abuse."
            }
        ]
    },
    // 12: Section 4 - Non-Harassment Policy
    {
        id: 12,
        type: 'section',
        title: "4- NON-HARASSMENT POLICY",
        text: `${companyName} is committed to providing a work environment free of unlawful harassment. Company policy prohibits sexual harassment, and harassment based on pregnancy, childbirth or related medical conditions, race, religious creed, color, national origin or ancestry, physical or mental disability, medical condition, marital status, age, sexual orientation or any other basis protected by federal, state or local law, ordinance or regulation. All such harassment is unlawful. The company's anti harassment policy applies to all persons involved in the operation of ${companyName} and prohibits unlawful harassment by any employee of ${companyName}, including managers, supervisors and co-workers.`,
        content_after: [
            {
                mode: 'p',
                text: "Prohibited unlawful harassment includes, but is not limited to, the following behavior:"
            },
            {
                mode: 'list',
                items: [
                    "a. Verbal conduct such as epithets, derogatory jokes or comments, slurs or unwanted sexual advances, invitations or comments;",
                    "b. Visual conduct such as derogatory and / or sexually-oriented posters, photography, cartoons, drawings or gestures;",
                    "c. Physical conduct such as assault, unwanted touching, blocking normal movement or interfering with work because of sex, race or any other protected basis;",
                    "d. Threats and demands to submit to sexual requests as a condition of continued employment, or to avoid some other loss and offers of employment benefits in return for sexual favors; and",
                    "e. Retaliation for having reported or threatened to report harassment."
                ]
            },
            {
                mode: 'p',
                text: `If you believe that you have been unlawfully harassed, provide a written complaint to your own or any other supervisor, or to the Agency's Administrator as soon as possible after the incident. If the alleged harasser is the Administrator, you may provide a written complaint to ${companyName}. The choice of whom to report the allegations of unlawful harassment is left to the employee in order to preclude having to report alleged unlawful harassment to the alleged harasser. Your complaint should include details of the incident(s), name(s) of the individual(s) involved and name(s) of any witness (s). Supervisors will refer all complaints of unlawful harassment to the Agency's Administrator. The agency will immediately undertake an effective, thorough and objective investigation of the harassment allegations.`
            },
            {
                mode: 'p',
                text: "A company representative will advise the parties concerned of the results of the investigation. If the agency or management company determines that unlawful harassment has occurred, effective remedial action will be taken in accordance with the circumstances involved. Any employee determined by the agency or management company to be responsible for unlawful harassment will be subject to disciplinary action, up to and including termination."
            }
        ]
    },
    // 13: Section 5 - Handbook Acknowledgement
    {
        id: 13,
        type: 'section',
        title: "5- Handbook Acknowledgement",
        text: `This is to acknowledge that I have received a copy of the Employee Handbook and understand that it contains important information on general personnel policies and on my privileges and obligations as an employee. I agree that I will read and comply with the materials in the Handbook which describes the general personnel policies governing my employment. If I do not understand any of these provisions, I agree to contact ${companyName} for clarification.`,
        content_after: [
            {
                mode: 'p',
                text: `I further understand that ${companyName} may change, supplement or rescind any policies, benefits, or practices described in the Handbook from time to time at its sole and absolute discretion, with or without prior notice with the exception of the employment at-will provisions.`
            },
            {
                mode: 'p',
                text: "No statement(s) in the Handbook or in other statement(s) of the Company policies, including statements made during performance appraisals, are to be construed either as an expressed or implied promise of continuing employment, unless expressly agreed and confirmed in writing by both the Company and the Employee."
            },
            {
                mode: 'p',
                text: `I understand and agree that other than the Administrator of ${companyName}, no manager, supervisor or representative of ${companyName} has authority to enter into any agreement, expressed or implied, for employment for any period of time, or to make any agreement for employment other than at-will. Only the Administrator has the authority to make any such agreement and then only in writing and signed by the Administrator.`
            },
            {
                mode: 'p',
                text: `Further, I understand that employment with ${companyName}, is for a specified term and is at the mutual consent of the employee and ${companyName} Accordingly, either the employee or ${companyName} can terminate the employment relationship at-will, with or without cause, at any time.`
            }
        ]
    },
    // 14: Section 6 - Acknowledgement of Universal Precautions
    {
        id: 14,
        type: 'section',
        title: "6- ACKNOWLEDGEMENT OF UNIVERSAL PRECAUTIONS",
        text: "The undersigned employee has been given the guidelines on AIDS and Hepatitis B as well as a copy of the policy and procedure on Universal Precautions and also the NOTE: \"The Center of Disease Control (CDC) advises that your greatest risk is up to twelve weeks after exposure to the blood borne pathogens\"."
    },
    // 15: Section 7 - Safety Policy and Procedure Acknowledgement
    {
        id: 15,
        type: 'section',
        title: "7- SAFETY POLICY AND PROCEDURE ACKNOWLEDGEMENT",
        text: `I, the undersigned, have read and understand the safety policies and procedures provided to me by ${companyName} I understand that these guidelines are provided to me for the safety of myself and my co-workers, and that it is my responsibility to review and comply with these policies and procedures.`
    },
    // 16: Section 8 - Submission of Clinical Notes Agreement
    {
        id: 16,
        type: 'section',
        title: "8- SUBMISSION OF CLINICAL NOTES AGREEMENT",
        text: "I agree that all documents relating to the patients, including the visit notes, route sheets, physician's order, etc. must be submitted to the Agency no later than five days after the date of the actual visits. Failure to comply with the above schedule will result in either suspension of the assignments and / or re-assignments of visits in order for deadlines to be met."
    },
    // 17: Section 9 - Employee Grievance Procedure
    {
        id: 17,
        type: 'section',
        title: "9- EMPLOYEE GRIEVANCE PROCEDURE",
        text: `It is the responsibility of ${companyName} Inc. to maintain employee satisfaction at all times. In order to minimize the possibility of misunderstanding, an employee is requested to discuss any problem or grievance with the employee's immediate supervisor as soon as possible after it arises. If the employee wishes to appeal the matter, such as disciplinary penalties or working conditions, the employee can formalize his/her complaint by following the grievance procedure outlined below:`,
        content_after: [
            {
                mode: 'steps',
                items: [
                    { step: "Step One:", text: "To complete a Grievance Report Form and submit it to his/her supervisor." },
                    { step: "Step Two:", text: "Discuss the grievance with the supervisor." },
                    { step: "Step Three:", text: "If the problem cannot be alleviating at the supervisory level, it should be discussed with the Administrator or Director of Patient Care Services." }
                ]
            },
            {
                mode: 'p',
                text: "The supervisor should document on the Grievance Report Form, the action taken to resolve the employee's grievance. A copy of the completed Grievance Report Form should be returned to the Administrator/Director of Patient Care Services."
            }
        ]
    },
    // 18: Section 10 - Receipt of Notice of Privacy Practices
    {
        id: 18,
        type: 'section',
        title: "10- RECEIPT OF NOTICE of PRIVACY PRACTICES",
        text: `This is to acknowledge that I have received a copy of ${companyName} Notice of Privacy Practices. I understand that this document provides an explanation of the ways in which the Agency's Patient's Health Information may be used or disclosed by ${companyName} and of their rights with respect to their health information.`
    },

];

const PtaWelcomLetter = ({role = 'PTA', onClose}) => {
    const { companyName } = useCurrentUser();
    const safeCompanyName = companyName || "Infinite Home Health, Inc.";
    return (
        <BaseWelcomeLetter
            onClose={onClose}
            role={role}
            items={getPtaWelcomeLetterItems(safeCompanyName)}
            title={`Welcome Letter And Agreement (${role})`}
            splitIndex={8}
        />
    );
};

export default PtaWelcomLetter;
